/**
 * Domain Type Detection — Sprint 1.5 Phase 1.5.6.
 *
 * Per DOMAIN_AWARE_AUTHORIZATION.md §4 Layer 4.
 *
 * Frontend defensive validation. Even if Backend leaks platform data
 * or token replay sneaks alcedo_operator role: PlatformConsolePage
 * refuses to render on dp_customer domain.
 */

export const DomainType = {
  ALCEDO_CONSOLE: 'alcedo_console',
  DP_CUSTOMER: 'dp_customer',
  DP_OPERATOR: 'dp_operator',
};

const DOMAIN_TYPE_MAPPING = {
  'console.alcedo-management.com': DomainType.ALCEDO_CONSOLE,
  'stag.console.alcedo-management.com': DomainType.ALCEDO_CONSOLE,
  'chat.airfarm.io': DomainType.DP_CUSTOMER,
  'stag.chat.airfarm.io': DomainType.DP_CUSTOMER,
  'localhost': DomainType.DP_CUSTOMER,
  '127.0.0.1': DomainType.DP_CUSTOMER,
};

/**
 * Detect domain type from current window.location.host.
 * Returns DP_CUSTOMER for unknown domains (defense-in-depth).
 */
export function getDomainType() {
  const host = window.location.host.split(':')[0].toLowerCase();
  return DOMAIN_TYPE_MAPPING[host] || DomainType.DP_CUSTOMER;
}

/** True if current page is on ALCEDO Platform Console domain. */
export function isAlcedoConsoleDomain() {
  return getDomainType() === DomainType.ALCEDO_CONSOLE;
}

/** True if current page is on Customer-Domain. */
export function isCustomerDomain() {
  return getDomainType() === DomainType.DP_CUSTOMER;
}

/** Tab IDs that must never appear on customer domain. */
export const PLATFORM_ONLY_TABS = new Set([
  'platform_dashboard',
  'distribution_partners',
  'system',
  'platform_audit',
  'platform_finance',
]);
